(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("KalturaPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["KalturaPlayer"] = factory();
	else
		root["KalturaPlayer"] = root["KalturaPlayer"] || {}, root["KalturaPlayer"]["plugins"] = root["KalturaPlayer"]["plugins"] || {}, root["KalturaPlayer"]["plugins"]["taxonomy-transcript"] = factory();
})(self, () => {
return 